
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-12e39832!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./coindistributionpanel.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./coindistributionpanel.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-12e39832!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./coindistributionpanel.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/dq-ui/packages/coindistributionpanel/src/coindistributionpanel.vue
// module id = 471
// module chunks = 36